/* ============================================================
   ISJ – Resaltar la variante seleccionada en la grilla de coleccion
   Marca con .active (borde rosa) el swatch que corresponde a la imagen
   principal que se esta mostrando en cada producto. Asi el resaltado
   coincide con la foto, y como el add-to-cart usa el swatch .active para
   elegir la variante, el cliente agrega justo la que ve.

   El handler del theme borra .active de TODA la grilla al clickear (bug),
   por eso re-marcamos los productos que quedaron sin seleccion tras click.
   ============================================================ */
(function () {
  // Nombre base de una imagen, sin el sufijo de tamano ni el query,
  // para poder comparar la foto principal (ej _600x) con la del swatch (_400x).
  function baseName(url) {
    if (!url) return '';
    var f = url.split('?')[0].split('/').pop().toLowerCase();
    f = f.replace(/_(\d+x\d*|pico|icon|thumb|small|compact|medium|large|grande|master)(?=\.\w+$)/, '');
    return f.replace(/\.(jpe?g|png|gif|webp|avif)$/, '');
  }

  function pickSwatch(group) {
    var card = group.closest ? group.closest('.thumbnail') : null;
    var mainImg = card ? card.querySelector('.pro-i-image') : null;
    var swatches = group.querySelectorAll('.swatch-element');

    // 1) el swatch cuya imagen coincide con la foto principal mostrada
    if (mainImg) {
      var mb = baseName(mainImg.getAttribute('src') || mainImg.src);
      if (mb) {
        for (var i = 0; i < swatches.length; i++) {
          if (baseName(swatches[i].getAttribute('data-image')) === mb) return swatches[i];
        }
      }
    }
    // 2) la variante default (.vid); 3) el primero disponible; 4) el primero
    var form = group.closest ? group.closest('form') : null;
    var vid = form ? form.querySelector('.vid') : null;
    if (vid && vid.value) {
      var m = group.querySelector('.swatch-element[data-variant="' + vid.value + '"]');
      if (m) return m;
    }
    return group.querySelector('.swatch-element.available') || group.querySelector('.swatch-element');
  }

  function ensureActive(root) {
    var groups = (root || document).querySelectorAll('.collection_swatches');
    for (var i = 0; i < groups.length; i++) {
      var g = groups[i];
      if (g.querySelector('.swatch-element.active')) continue; // ya tiene uno
      var t = pickSwatch(g);
      if (t && !t.classList.contains('soldout')) t.classList.add('active');
    }
  }

  // Tras un click, el theme limpia .active globalmente: re-marcamos.
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (!e.target.closest('.collection_swatches .swatch-element')) return;
    setTimeout(function () { ensureActive(); }, 0);
  }, true);

  function init() { ensureActive(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var mo = new MutationObserver(function () {
    clearTimeout(mo._t);
    mo._t = setTimeout(function () { ensureActive(); }, 150);
  });
  if (document.body) mo.observe(document.body, { childList: true, subtree: true });
})();
